// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mesprit: PokeData = {
  "id": 481,
  "name": "mesprit",
  "height": 3,
  "weight": 3,
  "base_experience": 261,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "recover",
    "swift",
    "rest",
    "tri-attack",
    "protect",
    "charm",
    "future-sight",
    "flatter",
    "imprison",
    "extrasensory",
    "calm-mind",
    "healing-wish",
    "natural-gift",
    "lucky-chant",
    "copycat",
    "double-hit",
    "mystical-power"
  ],
  "moves": [
    "psychic",
    "tri-attack",
    "protect",
    "future-sight",
    "flatter",
    "calm-mind",
    "healing-wish",
    "psy-ball",
    "reflect",
    "psychic-terrain",
    "synchronize",
    "psychic-fangs",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 242,
    "item": null,
    "species": [
      {
        "name": "mesprit",
        "order": 482,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 115,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
